import { CSSProperties, Dispatch, SetStateAction } from "react";
import { FileContainer } from "./FileContainer";

interface FileContainerProps {
  files: File[];
  setFiles: Dispatch<SetStateAction<File[]>>;
  style?: Object;
  textSx?: CSSProperties;
  fileContainerStyle?: CSSProperties;
}

export const FilesContainer = ({ files, setFiles, style = {}, textSx = {}, fileContainerStyle = {} }: FileContainerProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        overflowX: "auto",
        borderRadius: "0.625rem",
        position: "absolute",
        bottom: 0,
        left: 0,
        maxWidth: "80%",
        height: "fit-content",
        maxHeight: "6.250rem",
        gap: "0.25rem",
        ...style,
      }}
    >
      {files.map((file, idx) => (
        <FileContainer containerStyle={fileContainerStyle} key={idx} file={file} idx={idx} setFiles={setFiles} textStyle={textSx} />
      ))}
    </div>
  );
};

export default FilesContainer;
